<template>
  <Dropdown
    ref="dropdown"
    @on-click="handleClick"
    :class="hideTitle ? '' : 'collased-menu-dropdown'"
    :transfer="true"
    :placement="placement"
    transfer-class-name="transfer-class-name-overflow-auto"
  >
    <a
      :class="hideTitle ? 'hide-title-menu' : 'drop-menu-a'"
      type="text"
      @mouseover="handleMousemove($event, children)"
      :style="{ textAlign: !hideTitle ? 'left' : '' }"
      ><Icon
        :custom="'i-custom icon-' + parentItem.icon"
        :size="rootIconSize"
        :key="'icon' + parentItem.name" /><span
        class="menu-title"
        v-if="!hideTitle"
        >{{ parentItem.title }}</span
      ><Icon
        style="float: right;"
        v-if="!hideTitle"
        type="ios-arrow-forward"
        :size="16"
    /></a>
    <DropdownMenu ref="dropdown" slot="list">
      <template v-for="child in children">
        <collapsed-menu
          v-if="showChildren(child)"
          :icon-size="iconSize"
          :parent-item="child"
          :key="`drop-${child.name}`"
        ></collapsed-menu>
        <DropdownItem
          v-else
          :key="`drop-${child.name}`"
          :name="(child.id || child.children[0] && child.children[0].id) + '-' + (child.name || child.children[0] && child.children[0].name)"
          ><Icon
            :custom="'i-custom icon-' + child.icon"
            :size="iconSize"
            :key="'icon' + child.name"
          /><span class="menu-title">{{ child.title }}</span></DropdownItem
        >
      </template>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
import { findNodeUpperByClasses } from "@/libs/util";

export default {
  name: "CollapsedMenu",
  props: {
    hideTitle: {
      type: Boolean,
      default: false,
    },
    rootIconSize: {
      type: Number,
      default: 16,
    },
    parentItem: {
      type: Object,
      default: () => {},
    },
    theme: String,
    iconSize: Number,
  },
  data() {
    return {
      placement: "right-end",
    };
  },
  computed: {
    children() {
      return this.parentItem.children;
    },
    textColor() {
      return this.theme === "dark" ? "#fff" : "#383C4D";
    },
  },
  methods: {
    showChildren(item) {
      return item.children && item.children.length > 1;
    },
    handleClick(name) {
      this.$emit("on-click", name);
    },
    handleMousemove(event, children) {
      const { pageY } = event;
      const height = children.length * 38;
      const isOverflow = pageY + height < window.innerHeight;
      this.placement = isOverflow ? "right-start" : "right-end";
    },
  },
  mounted() {
    let dropdown = findNodeUpperByClasses(this.$refs.dropdown.$el, [
      "ivu-select-dropdown",
      "ivu-dropdown-transfer",
    ]);
    if (dropdown) dropdown.style.overflow = "visible";
  },
};
</script>

<style scoped>
a.drop-menu-a {
  display: inline-block;
  padding: 6px 15px;
  width: 100%;
  text-align: center;
  color: #383C4D;
}

a.hide-title-menu {
  display: block;
  width: 60px;
  padding: 10px 0;
  cursor: pointer;
  font-size: 20px;
  text-align: center;
  color: #A7ABB3;
}

.menu-title {
  padding-left: 6px;
}
</style>
<style>
.transfer-class-name-overflow-auto {
  overflow: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/collapsed-menu.vue